import styled from "styled-components";

interface StatusBadgeProps {
  status?: "approved" | "pending" | "rejected" | "deprecated";
  type?: "service" | "worker" | "ui";
  noBorder?: boolean;
}

const statusColors = {
  approved: "#10b981",
  active: "#10b981",
  pending: "#f59e0b",
  unlisted: "#f59e0b",
  rejected: "#ef4444",
  revoked: "#ef4444",
  deprecated: "#6b7280",
};

export const StatusBadge = styled.span<StatusBadgeProps>`
  display: inline-flex;
  gap: 6px;
  width: fit-content;
  align-items: center;
  padding: 6px 12px;
  color: ${({ status }) => (status ? statusColors[status] : "#6b7280")};
  border-radius: 20px;
  font-size: 12px;
  font-weight: 600;
  white-space: nowrap;

  ${({ noBorder, status }) => !noBorder && `
    border: 1px solid ${status ? statusColors[status] + "44" : "#6b728044"};
    background: ${status ? statusColors[status] + "22" : "#6b728022"};
  `}
`;